export default __webpack_public_path__ + "static/media/SettingsIllustration.8dc4c04e.png";